import React from 'react';

import Step from '../../../modules/step';

import './ucp-details-top.scss';

interface UcpDetailsTopProps {
  operationString: string;
  isUcpIssuing?: boolean;
}

const UcpDetailsTop: React.FC<UcpDetailsTopProps> = ({
  operationString,
  isUcpIssuing,
}) => {
  if (isUcpIssuing) {
    return (
      <div className="ucp__top">
        {/*<h3 className="h3">Проверьте и подпишите: </h3>*/}
        <p>{operationString}</p>
      </div>
    );
  }
  return (
    <div className="ucp__top">
      <Step
        steps={[
          { title: 'Параметры' },
          { title: 'Подпись', active: true },
          { title: 'Согласование' },
          { title: 'Подтвеждение оплаты' },
        ]}
      />
      <h3 className="h3">Проверьте и подпишите: </h3>
      {/*<h3 className="h3">Проверьте и подпишите: </h3>*/}
      <p>{operationString}</p>
    </div>
  );
};

export default UcpDetailsTop;
